import { useFormContext } from 'react-hook-form'
import { usePaymentInputs } from 'react-payment-inputs'
import images from 'react-payment-inputs/images'

import { Form } from '@tribeplatform/react-sdk/components'
import { useUpdateBillingDetails } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

const CreditCardInputs = () => {
  const {
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
  } = usePaymentInputs()
  const { setValue } = useFormContext()

  return (
    <>
      <Form.Input
        name="cardNumber"
        label="Credit card number"
        leadingIcon={<svg {...getCardImageProps({ images })} />}
        {...getCardNumberProps({
          onChange: x => setValue('cardNumber', x.target.value),
        })}
        validation={{
          required: 'Credit card number is required',
        }}
      />
      <Form.Input
        name="expiryDate"
        label="Expiry date"
        {...getExpiryDateProps({
          onChange: x => setValue('expiryDate', x.target.value),
        })}
        validation={{
          required: 'Expiry date is required',
        }}
      />
      <Form.Input
        name="cvc"
        label="CVC"
        {...getCVCProps({
          onChange: x => setValue('cvc', x.target.value),
        })}
        validation={{
          required: 'CVC is required',
        }}
      />
    </>
  )
}

export const ChangePaymentMethodModal = ({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) => {
  const { mutateAsync: updateBillingDetails, isLoading } =
    useUpdateBillingDetails()

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header title="Change Billing Details" />
      <Modal.Content>
        <Form
          onSubmit={async data => {
            const { cardNumber, cvc, expiryDate, name } = data
            const [expirationMonth, expirationYear] = expiryDate?.split('/')
            try {
              await updateBillingDetails({
                input: {
                  card: {
                    cardNumber: cardNumber?.split(' ').join(''),
                    cvc,
                    nameOnCard: name,
                    expirationMonth: parseInt(expirationMonth?.trim(), 10),
                    expirationYear: parseInt(expirationYear?.trim(), 10),
                  },
                },
              })
              toast({
                title: 'Payment method updated',
                status: 'success',
              })
            } catch {
              toast({
                title: 'Unable to update payment method',
                status: 'error',
              })
            }
          }}
        >
          <div className="flex flex-col space-y-5">
            <CreditCardInputs />
            <Form.Input
              label="Name on card"
              name="name"
              autoComplete="cc-name"
            />
            <Form.Actions>
              <Button type="submit" loading={isLoading}>
                Update
              </Button>
            </Form.Actions>
          </div>
        </Form>
      </Modal.Content>
    </Modal>
  )
}
